var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconAdmin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-2{fill:#fff}\n        "))), /*#__PURE__*/React.createElement("g", {
    id: "Group_944",
    "data-name": "Group 944",
    transform: "translate(-33 -144)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_973",
    "data-name": "Rectangle 973",
    transform: "translate(33 144)",
    style: {
      fill: "none"
    },
    d: "M0 0h32v32H0z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2_",
    transform: "translate(40.964 150.971)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_228",
    "data-name": "Group 228"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_227",
    "data-name": "Group 227"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_108",
    "data-name": "Path 108",
    className: "cls-2",
    d: "M38.406 280.98a3.927 3.927 0 0 1-3.179 1.622H33.4a1.463 1.463 0 0 1-1.375-.964 4.648 4.648 0 0 1-.74-.292 4.982 4.982 0 0 1-1.381-1.023 5.9 5.9 0 0 0-4.626 5.759v.369a.918.918 0 0 0 .918.918h14.232a.918.918 0 0 0 .918-.918v-.369a5.894 5.894 0 0 0-2.94-5.102z",
    transform: "translate(-25.274 -269.311)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_109",
    "data-name": "Path 109",
    className: "cls-2",
    d: "M92.653 9.121a1.044 1.044 0 0 0 .915-.541l.014.038v.011a4.078 4.078 0 0 0 2.3 2.421 1.461 1.461 0 0 1 1.239-.685h1.831a1.025 1.025 0 0 0 .5-.135 2.07 2.07 0 0 0 .592-.683 5.28 5.28 0 0 0 .458-.968 1.05 1.05 0 0 0 .289.333v.449a1.842 1.842 0 0 1-1.84 1.84h-1.826a.627.627 0 0 0 0 1.254h1.831a3.1 3.1 0 0 0 3.094-3.094v-.449a1.043 1.043 0 0 0 .418-.836V5.461a1.043 1.043 0 0 0-.434-.847 5.012 5.012 0 0 0-9.992 0 1.043 1.043 0 0 0-.434.847v2.615a1.045 1.045 0 0 0 1.045 1.045zm4.385-7.867a3.763 3.763 0 0 1 3.74 3.386 1.049 1.049 0 0 0-.294.363A3.577 3.577 0 0 0 93.594 5v.006a1.049 1.049 0 0 0-.294-.363 3.764 3.764 0 0 1 3.738-3.389z",
    transform: "translate(-89.002)"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAdmin);
export default __webpack_public_path__ + "static/media/icon-admin.0472b653.svg";
export { ForwardRef as ReactComponent };